import { Checkmark } from '@carbon/icons-react';
import { Checkbox as CheckboxJoy, checkboxClasses } from '@mui/joy';
import { styled } from '@mui/joy/styles';
import { SxProps } from '@mui/joy/styles/types';
import { ChangeEvent, ForwardedRef, forwardRef, ReactNode } from 'react';
import styleToCss from 'style-object-to-css-string';

export interface CheckboxProps {
  value?: string | number;
  label?: string | ReactNode;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  error?: boolean;
  sx?: SxProps;
}

// value and error are not used, but they raise an warning if passed down to Joy UI checkbox
const Checkbox = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: CheckboxProps, ref: ForwardedRef<any>): JSX.Element => (
    <StyledCheckbox ref={ref} checkedIcon={<Checkmark size={24} />} {...props} />
  ),
);

export default Checkbox;

const StyledCheckbox = styled(CheckboxJoy)<{ error?: boolean }>`
  &.${checkboxClasses.root} {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }

  & .${checkboxClasses.label} {
    ${({ theme }) => styleToCss(theme.typography['body-md'])};
  }

  & .${checkboxClasses.checkbox} {
    width: 24px;
    height: 24px;
    border-radius: 2px;
    background-color: transparent;
  }

  & .${checkboxClasses.checkbox}:hover {
    background-color: white;
  }

  & .${checkboxClasses.checkbox}.${checkboxClasses.checked} {
    background-color: ${({ theme }) => theme.vars.palette.salmon};
    color: white;
  }
`;
